export enum ReportTypeEnum {
  REVENUE = 'REVENUE',
  PROFIT = 'PROFIT',
  VOLUME = 'VOLUME',
  ACTIVITY = 'ACTIVITY',
  PROFITABILITY = 'PROFITABILITY',
  EXPENSES = 'EXPENSES',
  SALES_AVG_PRICE = 'SALES_AVG_PRICE',
  PURCHASE_AVG_PRICE = 'PURCHASE_AVG_PRICE',
}
